import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PlanLimitBanner = () => {
    const { t } = useTranslation("your_testimonial");
    const navigate = useNavigate();
    
    const upgardePlan = () => {
        navigate('/rate')
    }

    return (
        <div className="p-4 bg-[#3686ff] z-50 shadow-lg rounded-xl border border-gray-300 flex flex-col md:flex-row justify-between items-center px-5">
            <span className="text-sm md:text-base text-white mb-2 md:mb-0 md:mr-4 text-center md:text-left">
            {t('plan_limit_exceeded_msg')}
            </span>
            <button
                onClick={upgardePlan}
                className="bg-white hover:bg-white text-[#3686ff] border-none rounded-md px-4 py-2 text-sm md:text-base cursor-pointer transition-all"
            >
                {t('upgrade_btn')}
            </button>
        </div>
    );
};

export default PlanLimitBanner;
